export default "__VITE_ASSET__CAgWvG3B__"